import business from '@/utils/business'
export function wxbilllist(data) {
  return business.post('/wxbill/list', data)
}

export function modify(data) {
  return business.post('/wxbill/modify', data)
}


export function billadd(data) {
  return business.post('/wxbill/add', data)
}



// WEBPACK FOOTER //
// ./src/api/Hrbill.js